import React, { Component } from 'react';
import './ServiceTerms.css';

class ServiceTerms extends Component {
  render() {
    return (
      <div className="ServiceTerms">
        <div className="contents">
          <h1 style={{ alignSelf: "center", fontFamily: "NanumBarunGothicBold" }}>
            서비스 이용약관
          </h1>
          <br />

          <span id="section1">
            본 약관은 레몬케이크(이하 “회사”)가 제공하는 도서 리뷰 및 회원 간
            채팅 서비스 플랫폼 “자정의 도서관”(이하 “서비스”)을 이용함에 있어
            회사와 회원 간의 권리·의무 및 제반 사항을 규정함을 목적으로 합니다.
          </span>

          <br /><br />

          <span className="first">제1조 (약관의 게시 및 개정)</span><br />
          <span className="second">
            ① 회사는 본 약관을 회원이 쉽게 확인할 수 있도록 서비스 초기 화면
            또는 연결 화면을 통해 게시합니다.
          </span><br />
          <span className="second">
            ② 회사는 관련 법령을 위반하지 않는 범위에서 본 약관을 개정할 수
            있습니다.
          </span><br />
          <span className="second">
            ③ 약관을 개정하는 경우, 회사는 시행일 7일 전부터 공지하며, 회원에게
            중대하거나 불리한 변경의 경우 30일 전에 별도 공지합니다.
          </span><br />
          <span className="second">
            ④ 회원은 개정 약관에 동의하지 않을 경우 서비스 탈퇴를 요청할 수
            있습니다.
          </span><br />
          <span className="second">
            ⑤ 시행일까지 명시적 거부 의사를 표시하지 않은 경우 개정 약관에
            동의한 것으로 봅니다.
          </span>

          <br /><br />

          <span className="first">제2조 (약관의 효력 및 준칙)</span><br />
          <span className="second">
            ① 본 약관은 회원이 동의함으로써 효력이 발생합니다.
          </span><br />
          <span className="second">
            ② 본 약관에서 정하지 않은 사항은 관련 법령 및 회사의 운영정책을
            따릅니다.
          </span><br />
          <span className="second">
            ③ 회사는 개별 서비스에 대해 별도의 약관을 둘 수 있으며, 개별약관이
            본 약관에 우선합니다.
          </span>

          <br /><br />

          <span className="first">제3조 (회원의 계정 및 프로필 관리 의무)</span><br />
          <span className="second">
            ① 회원은 자신의 계정 및 프로필 정보를 스스로 관리할 책임이 있습니다.
          </span><br />
          <span className="second">
            ② 계정 도용 또는 무단 사용으로 발생한 문제에 대해 회사는 고의 또는
            과실이 없는 한 책임을 지지 않습니다.
          </span><br />
          <span className="second">
            ③ 회원은 계정 정보 유출 사실을 인지한 경우 즉시 회사에 통지해야
            합니다.
          </span>

          <br /><br />

          <span className="first">제4조 (회사와 회원 간의 관계)</span><br />
          <span className="second">
            ① 회사는 안정적인 서비스 제공을 위해 최선을 다합니다.
          </span><br />
          <span className="second">
            ② 회사는 회원 간 분쟁에 대해 통신판매중개자로서 법적 책임의 범위
            내에서만 관여합니다.
          </span><br />
          <span className="second">
            ③ 회원 간 분쟁은 당사자 간 해결을 원칙으로 합니다.
          </span>

          <br /><br />

          <span className="first">제5조 (회원 가입 및 탈퇴)</span><br />
          <span className="second">
            ① 회원 가입은 본 약관에 동의한 후 신청할 수 있습니다.
          </span>
          <ul>
            <li className="third">만 14세 미만인 경우</li>
            <li className="third">허위 정보 또는 타인 정보 도용</li>
            <li className="third">과거 자격 상실 후 1년 미경과</li>
            <li className="third">기타 회사가 부적절하다고 판단한 경우</li>
          </ul>
          <span className="second">
            ② 회원은 언제든지 계정 탈퇴를 요청할 수 있으며, 개인정보는
            개인정보처리방침에 따라 처리됩니다.
          </span>

          <br /><br />

          <span className="first">제6조 (회원의 의무 및 자격 제한)</span><br />
          <ul>
            <li className="third">타인의 개인정보 도용</li>
            <li className="third">불법·음란·폭력적 콘텐츠 게시</li>
            <li className="third">저작권 등 권리 침해</li>
            <li className="third">서비스 운영 방해 행위</li>
            <li className="third">광고성 정보 무단 전송</li>
          </ul>
          <span className="second">
            회사는 위반 행위가 중대하거나 반복될 경우 서비스 이용을 제한할 수
            있습니다.
          </span>

          <br /><br />

          <span className="first">제7조 (서비스의 제공)</span><br />
          <ul>
            <li className="third">도서 리뷰 작성 및 열람</li>
            <li className="third">회원 간 채팅</li>
            <li className="third">도서 커뮤니티 서비스</li>
            <li className="third">기타 부가 서비스</li>
          </ul>
          <span className="second">
            회사는 서비스 개선을 위해 기능을 변경할 수 있습니다.
          </span>

          <br /><br />

          <span className="first">제8조 (게시물 관리)</span><br />
          <span className="second">
            ① 게시물의 저작권은 작성자에게 귀속됩니다.
          </span><br />
          <span className="second">
            ② 회사는 서비스 운영 목적 범위 내에서 게시물을 사용할 수 있습니다.
          </span><br />
          <span className="second">
            ③ 타인의 권리를 침해하는 게시물은 사전 통보 없이 삭제될 수 있습니다.
          </span>

          <br /><br />

          <span className="first">제9조 (서비스 중지 및 종료)</span><br />
          <span className="second">
            ① 불가항력 사유 발생 시 서비스 제공이 일시 중단될 수 있습니다.
          </span><br />
          <span className="second">
            ② 회사는 경영상 필요 시 서비스 종료를 공지 후 시행할 수 있습니다.
          </span>

          <br /><br />

          <span className="first">제10조 (분쟁 해결 및 관할)</span><br />
          <span className="second">
            ① 회사와 회원 간 분쟁은 협의를 통해 해결함을 원칙으로 합니다.
          </span><br />
          <span className="second">
            ② 협의가 이루어지지 않을 경우 관할 법원에 소를 제기할 수 있습니다.
          </span>

          <br /><br />

          <span className="first">부칙</span><br />
          <span className="second">
            본 약관은 2025년 5월 1일부터 시행됩니다.
          </span>
        </div>
      </div>
    );
  }
}

export default ServiceTerms;